<template>
  <HeadlineComponent :subtitle="`Insgesamt ${tickets.length} Tickets`">Tickets</HeadlineComponent>
  <table class="table table-striped">
    <thead>
    <tr>
      <th>Name</th>
      <th>Ticket Typ</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="ticket of sortedTickets" :key="ticket.id">
      <td>{{ ticket.full_name }}</td>
      <td>{{ ticket.ticket_template.name }}</td>
    </tr>
    </tbody>
  </table>

</template>

<script>
import {mapActions} from "pinia";
import {useAlertsStore} from "@/stores/alerts.js";
import ticketService from "@/services/ticket.service.js";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import * as Sentry from '@sentry/vue';

export default {
  name: "TicketsView",
  components: {HeadlineComponent},
  data() {
    return {
      tickets: []
    }
  },
  methods: {
    ...mapActions(useAlertsStore, {addAlert: 'add'})
  },
  async beforeRouteEnter(to, from, next) {
    let tickets = []
    try {
      let response = await ticketService.index();
      tickets = response.data;
      for(let i=0;i<tickets.length;i++) {
        if(tickets[i].user && tickets[i].user.id) {
          tickets[i].first_name = tickets[i].user.first_name
          tickets[i].last_name = tickets[i].user.last_name
          tickets[i].full_name = tickets[i].user.full_name
        } else {
          tickets[i].first_name = tickets[i].guest.first_name
          tickets[i].last_name = tickets[i].guest.last_name
          tickets[i].full_name = tickets[i].guest.full_name
        }
      }
    } catch (e) {
      if (e) {
        Sentry.captureException(e);
        useAlertsStore().add('danger', "Es ist was unerwartetes schief gegangen..");
        window.scrollTo(0, 0);
      }
    }
    next(vm => {vm.tickets = tickets})
  },
  computed: {
    sortedTickets() {
      return this.tickets.slice().sort((a, b) => {
        if (a.last_name === b.last_name) return 0;
        if (a.last_name > b.last_name) return 1;
        if (a.last_name < b.last_name) return -1;
      })
    }
  }
}
</script>

<style scoped>

</style>